import { useEffect } from 'react';
import { ActionResult } from '../components/Button';

const useSaveShortcut = (
  save: (() => Promise<void>) | (() => Promise<ActionResult>)
) => {
  useEffect(() => {
    const handleKeyDown = async (event: KeyboardEvent) => {
      const isSaveShortcut =
        (event.ctrlKey || event.metaKey) && event.key === 's';
      if (isSaveShortcut) {
        event.preventDefault();
        await save(); // Await the async save function
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [save]);
};

export default useSaveShortcut;
